import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetCarriersQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.CarrierDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.CarrierDocumentSortInput> | Types.CarrierDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetCarriersQuery = { __typename?: 'Query', carriers?: { __typename?: 'CarriersConnection', totalCount: number, nodes?: Array<{ __typename?: 'CarrierDocument', tenantId: string, carrier: string }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };


export const GetCarriersDocument = new TypedDocumentString(`
    query GetCarriers($where: CarrierDocumentFilterInput, $order: [CarrierDocumentSortInput!], $first: Int, $after: String) {
  carriers(where: $where, order: $order, first: $first, after: $after) {
    nodes {
      tenantId
      carrier
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetCarriers: build.query<GetCarriersQuery, GetCarriersQueryVariables | void>({
      query: (variables) => ({ document: GetCarriersDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetCarriersQuery, useLazyGetCarriersQuery } = injectedRtkApi;
